var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactCardPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#7896D2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.154 6.278c0 3.467-2.811 6.277-6.278 6.277-3.466 0-6.277-2.81-6.277-6.277C1.6 2.812 4.41 0 7.876 0s6.278 2.812 6.278 6.278M13.695 15.656c1.137 0 2.06.922 2.06 2.059s-.923 2.06-2.06 2.06H2.06c-1.137 0-2.06-.923-2.06-2.06s.923-2.06 2.06-2.06h11.635z",
    transform: "translate(-317 -700) translate(8 409) translate(73 277) translate(236 14)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactCardPerson);
export default __webpack_public_path__ + "static/media/contactCardPerson.8769a0a1c00667499888accf69ad7249.svg";
export { ForwardRef as ReactComponent };